import {
  Alert,
  Box,
  Divider,
  Grid2 as Grid,
  Link,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { retrieveAllBlogs } from "../../../redux/specialist-slices/blog.slice";
import { useDispatch, useSelector } from "react-redux";
import { FILE_PATH_URI } from "../../../utils/helper";
import SkeletonImage from "../../ui/SkeletonImage";
import { Link as NavLink } from "react-router-dom";
import { useEffect, useState } from "react";
import moment from "moment";

function AllBlogs() {
  const dispatch = useDispatch();
  const [data, setdata] = useState({});
  const { loadings } = useSelector((state) => state.otherSlice);

  // Handle get all blogs
  const handleretrieveAll = async () => {
    const response = await dispatch(
      retrieveAllBlogs({
        limit: 100,
      })
    ).unwrap();
    setdata(response);
  };

  useEffect(() => {
    handleretrieveAll();

    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        p: 3,
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Grid container spacing={2}>
        {loadings?.retrieveAll ? (
          new Array(4).fill().map((_, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Skeleton
                sx={{
                  width: "100%",
                  height: "100%",
                  transform: "none",
                  aspectRatio: "1/0.5",
                }}
              />
            </Grid>
          ))
        ) : data?.records?.length === 0 ? (
          <Grid size={12}>
            <Alert
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                alignItems: "center",
                fontFamily: "Poppins",
                ".MuiAlert-message": { p: "0" },
                ".MuiAlert-icon": { fontSize: "28px" },
              }}
              color="error"
              severity="error"
            >
              No Records Found!
            </Alert>
          </Grid>
        ) : (
          data?.records?.map((element, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Paper
                sx={{
                  p: 2,
                  gap: 1,
                  height: "100%",
                  display: "flex",
                  borderRadius: "6px",
                  border: "1px solid",
                  borderColor: "divider",
                  flexDirection: "column",
                  transition: "all 450ms ease",
                  boxShadow: "0 0 10px 0 #0000000a",
                  ":hover": {
                    transform: "scale(1.01)",
                    boxShadow: "0 0 10px 0 #00000021",
                  },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "6px",
                    aspectRatio: "1/0.6",
                  }}
                >
                  <SkeletonImage src={FILE_PATH_URI + element?.banner?.path} />
                </Box>

                <Stack spacing={2} sx={{ flexGrow: 1 }}>
                  <Divider />
                  <Link
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      WebkitLineClamp: 1,
                      color: "other.color1",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      transition: "all 350ms ease",
                      ":hover": {
                        color: "primary.main",
                      },
                    }}
                    fontSize={20}
                    fontWeight="500"
                    underline="hover"
                    to={`/blog/${element?._id}`}
                    component={NavLink}
                  >
                    {element?.title}
                  </Link>
                  <Box
                    sx={{
                      overflow: "hidden",
                      WebkitLineClamp: "2",
                      display: "-webkit-box",
                      textOverflow: "ellipsis",
                      WebkitBoxOrient: "vertical",
                    }}
                    dangerouslySetInnerHTML={{ __html: element?.description }}
                  />
                  <Typography
                    mt="auto !important"
                    lineHeight="1"
                    fontWeight="500"
                    component="span"
                    color="other.color2"
                  >
                    {moment(element?.createdAt).format("MMM DD YYYY")}
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          ))
        )}
      </Grid>
    </Box>
  );
}

export default AllBlogs;
